import React from 'react'
import { Redirect } from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import { useDispatch } from 'react-redux'
import { logoutUser } from './auth-utils'

// Create a functional component for the UI portion
export function LogoutPage() {
  return <Redirect to='/agent-application/login' />
}

// Create a separate logout action function that doesn't use hooks
export function handleLogout(dispatch: any) {
  if (dispatch) {
    dispatch(auth.actions.logout())
  }

  // Use centralized logoutUser function that will notify all tabs and redirect with clean URL
  logoutUser(true)

  // Clear any additional data not handled by logoutUser
  localStorage.removeItem('agentCode')
  localStorage.removeItem('userDetails')
  localStorage.removeItem('env')
  localStorage.removeItem('partnerId')
  localStorage.removeItem('partnerDetails')

  // Don't reload the page here - let React handle navigation
}

// Export the main component that combines both
export function Logout() {
  const dispatch = useDispatch()

  // Call the logout action once on mount
  React.useEffect(() => {
    handleLogout(dispatch)
  }, [dispatch])

  return <LogoutPage />
}
